<div>
    <h2>{{'mantenimientoVersionesEtiquetado.titulo' | translate}}</h2>
    <section class="filters-framed" *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" [ngClass]="{'show-error':showError}">
            <div class="entry-single">
                <label>{{'mantenimientoVersionesEtiquetado.filters.observaciones' | translate}}</label>
                <input type="text" formControlName="observaciones">
            </div>
        </form>
    </section>
    <section class="filters-buttons">
        <button *ngIf="!filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.abrir' | translate}}">
            <i class="fas fa-filter"></i> {{'global.filtros.filtrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary" [ngClass]="{'showFilters': filtersVisible}"
            (click)="filtersVisible=!filtersVisible" title="{{'global.filtros.cerrar' | translate}}">
            <i class="fas fa-times"></i> {{'global.filtros.cerrar' | translate}}
        </button>
        <button *ngIf="filtersVisible" class="secondary"
            [ngClass]="{'showFilters': filtersVisible, 'secondary-disabled': !checkValuesForm()}" (click)="resetForm()"
            title="{{'global.filtros.limpiar' | translate}}">
            <i class="fas fa-eraser"></i> {{'global.filtros.limpiar' | translate}}
        </button>
        <button *ngIf="filtersVisible" [ngClass]="{'showFilters': filtersVisible}"
            title="{{'global.filtros.filtrar' | translate}}" (click)="filtrar()">
            <i class="fas fa-filter"></i> {{'global.filtros.aplicar' | translate}}
        </button>
    </section>
    <!-- <button (click)="getContainers()"></button> -->
     <div class="table-wrapper">
        <div class="table-container">
            <table>
                <thead>
                    <tr>
                        <th class="icon"></th>
                        <th class="string">{{'mantenimientoVersionesEtiquetado.table.version' | translate}}</th>
                        <th class="date-long">{{'global.fecha.insercionShort' | translate}}</th>
                        <th class="date-long">{{'global.fecha.actualizacionShort' | translate}}</th>
                        <th class="multi-actions-bigSubtable">
                            <i class="fas fa-plus" (click)="create()" title="{{'mantenimientoVersionesEtiquetado.table.addVersion' | translate}}"></i>
                        </th>
                    </tr>
                </thead>
                <tbody *ngFor="let versionSw of versionesSw; let i=index; trackBy: trackByVersionSwId">
                    <tr [ngClass]="{'dropdownInfo': dropdownInfo === i}" (click)="showDetails(i)">
                        <td class="icon"><i [ngClass]="dropdownInfo === i ? 'fas fa-angle-down fa-sm' : 'fas fa-angle-right fa-sm'"
                            title="{{dropdownInfo === i ? ('global.minimizarInfo' | translate) : ('global.masInfo' | translate)}}"></i>
                        </td>
                        <td class="string">{{versionSw.des}}</td>
                        <td class="date-long">{{versionSw.fechaIns | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="date-long">{{versionSw.fechaUpd | date: 'shortDate' : undefined : defaultLanguage}}</td>
                        <td class="multi-actions-bigSubtable">
                            <i class="fas fa-stream" app-click-stop-propagation (click)="openTabs(i)" title="{{dropdownSection === i ? ('global.minimizarDetalle' | translate) : ('global.mostrarDetalle' | translate)}}" app-click-stop-propagation></i>
                            <i class="fa solid fa-upload" [ngStyle]="{'color': versionSw.refArchivoInstalador ? '' : 'rgb(255, 165, 0)' }" (click)="openUpload(versionSw, false)" title="{{'mantenimientoVersionesEtiquetado.upload.subirInstalador' | translate}}" app-click-stop-propagation></i>
                            <i class="fa solid fa-upload" [ngStyle]="{'color': versionSw.refArchivoActualizador ? '' : 'rgb(255, 165, 0)' }" (click)="openUpload(versionSw, true)" title="{{'mantenimientoVersionesEtiquetado.upload.subirActualizador' | translate}}" app-click-stop-propagation></i>
                            <i class='fas fas fa-pencil-alt' (click)="update(versionSw)" app-click-stop-propagation title="{{'mantenimientoVersionesEtiquetado.table.editar' | translate}}" app-click-stop-propagation></i>
                            <i class="far fa-trash-alt" title="{{'mantenimientoVersionesEtiquetado.table.eliminar' | translate}}" (click)="askDelete(versionSw)" app-click-stop-propagation ></i>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownInfo === i">
                        <td colspan="5">
                            <div class="detail">
                                <div class="title">{{'global.masInformacion' | translate}}</div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.nombreArchivoInstalaccion' | translate}}</label>
                                    <p>{{versionSw.refArchivoInstalador}}</p>
                                    <i class="fa fa-copy" *ngIf="versionSw.urlArchivoInstalador" title="{{'titles.copiarValor' | translate}}" app-click-stop-propagation (click)="copyInstalador(versionSw.urlArchivoInstalador)"></i>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.tamaño' | translate}}</label>
                                    <p>{{versionSw.tamanyoKbArchivoInstalador}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.nombreArchivoActualizacion' | translate}}</label>
                                    <p>{{versionSw.refArchivoActualizador}}</p>
                                    <i class="fa fa-copy" *ngIf="versionSw.urlArchivoActualizador" title="{{'titles.copiarValor' | translate}}" app-click-stop-propagation (click)="copyActualizador(versionSw.urlArchivoActualizador)"></i>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.tamaño' | translate}}</label>
                                    <p>{{versionSw.tamanyoKbArchivoActualizador}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.observaciones' | translate}}</label>
                                    <p>{{versionSw.observaciones}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.nLicencias' | translate}}</label>
                                    <p>{{versionSw.numLicenciasVersionActual}}</p>
                                </div>
                                <div class="block-inline">
                                    <label>{{'mantenimientoVersionesEtiquetado.table.nLicenciasPendientes' | translate}}</label>
                                    <p>{{versionSw.numLicenciasVersionPendienteActualizar}}</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr *ngIf="dropdownSection === i">
                        <td colspan="3">
                            <section class="tabs">
                                <ul>
                                    <li class="active">{{'mantenimientoVersionesEtiquetado.tabs.actualizaciones.titulo' | translate}}</li>
                                </ul>
                                <content>
                                    <table>
                                        <thead>
                                            <tr>
                                                <th class="string">{{'global.pais' | translate}}</th>
                                                <th class="string">{{'mantenimientoVersionesEtiquetado.tabs.actualizaciones.denominacion' | translate}}</th>
                                                <th class="string">{{'mantenimientoVersionesEtiquetado.tabs.actualizaciones.nLicencias' | translate}}</th>
                                                <th class="action"></th>
                                            </tr>
                                        </thead>
                                        <tbody *ngFor="let actualizacion of versionSw.lsActualizacionAutomaticaPD; let i=index">
                                            <tr>
                                                <td class="string">{{actualizacion.desPais}}</td>
                                                <td class="string">{{actualizacion.desDenominacion}}</td>
                                                <td class="string">{{actualizacion.numLicenciasVersionPendienteActualizar}}</td>
                                                <td class="actions">
                                                    <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" (click)="askDeleteActualizacion(actualizacion)" app-click-stop-propagation></i>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </content>
                            </section>
                        </td>
                    </tr>
                </tbody>
                <tfoot *ngIf="!versionesSw || (versionesSw && versionesSw.length < 1)">
                    <tr>
                        <td colspan="5">
                            {{'global.noContent' | translate}}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
     </div>
    <app-paginator *ngIf="versionesSw && versionesSw.length > 0" [itemsPerPage]="itemsPerPage"
        [currentPage]="currentPage + 1" [totalItems]="totalItems" [visiblePages]="visiblePages"
        (pageChange)="pageChange($event)" (itemsPerPageChange)="itemsPerPageChange($event)">
    </app-paginator>
    <app-toast *ngIf="(showError) && mensajes" [messages]="mensajes" (closed)="showError=$event">
    </app-toast>
</div>
<div class="modal" *ngIf="deleteModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="delete()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>
<div class="modal" *ngIf="newEditModal">
    <div class="modal-content">
        <header>
            <h4>{{versionSwId ? ('mantenimientoVersionesEtiquetado.tituloEdit' | translate) :
                ('mantenimientoVersionesEtiquetado.tituloNew' | translate)}}</h4>
        </header>
        <app-versiones-etiquetado-new-edit [versionSwId]="versionSwId" (refresh)="refresh($event)" (mensaje)="pushMessage($event)"></app-versiones-etiquetado-new-edit>
    </div>
</div>
<div class="modal" *ngIf="uploadModal">
    <div class="modal-content">
        <header>
            <h4>{{'mantenimientoVersionesEtiquetado.upload.tituloAsociar' | translate}}</h4>
        </header>
        <app-upload-file [versionSwId]="versionSwId" [update]="updateFile"
            (refresh)="refresh($event)" (mensaje)="pushMessage($event)">
        </app-upload-file>
    </div>
</div>
<div class="modal" *ngIf="deleteActualizacionesModal">
    <div class="modal-content">
        <header>
            <h4>{{'global.eliminar.descripcion' | translate}}</h4>
        </header>
        <content>
            <p>{{'global.eliminar.confirmacion' | translate}}</p>
        </content>
        <footer>
            <button class="secondary" (click)="close()">{{'global.cancelar' | translate}}</button>
            <button (click)="deleteActualizacion()">{{'global.confirmar' | translate}}</button>
        </footer>
    </div>
</div>